import { combineReducers } from "redux";
import { locationDataReducer } from "./searchReducers";

const rootReducer = combineReducers({
  locationDataReducer,
});

export default rootReducer;
